import { render, staticRenderFns } from "./EDialogTips.vue?vue&type=template&id=0885bdca&scoped=true"
import script from "./EDialogTips.vue?vue&type=script&lang=js"
export * from "./EDialogTips.vue?vue&type=script&lang=js"
import style0 from "./EDialogTips.vue?vue&type=style&index=0&id=0885bdca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.1__lodash@4.18.1__ulpx2buzx6ym2m5ug44v2geldi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885bdca",
  null
  
)

export default component.exports